import {Box, Button, ButtonGroup, Container, HStack, Spacer} from '@chakra-ui/react'
import {NavLink, useLocation} from 'react-router-dom'
import useAuthStore from '../../stores/authStore'
import LogOutButton from './LogOutButton/LogOutButton'
import {useEffect, useCallback} from 'react'
import { use } from 'react'

export const NavBar = () => {
    const accessToken = useAuthStore((state) => state.accessToken)
    const user = useAuthStore((state) => state.user)

    const location = useLocation()
    

    const isCurrentPath = useCallback((path) => {
        return location.pathname === path || (path === '/countings' && (location.pathname.startsWith('/counting') || location.pathname.startsWith('/stores')))
    }, [location.pathname])

    return (
        <Box as='section'>
            <Box as='nav' bg='bg-surface' boxShadow='sm'>
                <Container py={{ base: '4', lg: '5' }}>
                    <HStack spacing='10' justify='space-between' width='100%'>

                        <ButtonGroup variant='link' spacing='8'>
                            {!!accessToken?.length && (
                                <>
                                    <Button as={NavLink} to='/countings' variant={isCurrentPath('/countings') ? 'outline' : ''}>
                                        Countings
                                    </Button>
                                    {(user?.is_admin || user?.is_counting_manager) && (
                                        <>
                                        <Button as={NavLink} to='/companies' variant={isCurrentPath('/companies') ? 'outline' : ''}>
                                            Companies
                                        </Button>
                                        <Button as={NavLink} to='/users' variant={isCurrentPath('/users') ? 'outline' : ''}>
                                            Workers
                                        </Button>
                                        <Button as={NavLink} to='/statistics' variant={isCurrentPath('/statistics') ? 'outline' : ''}>
                                            Statistics
                                        </Button>
                                        {user?.is_admin && (
                                            <Button as={NavLink} to='/working-hours' variant={isCurrentPath('/working-hours') ? 'outline' : ''}>
                                                Hours
                                            </Button>
                                        )}
                                        </>
                                     )}
                                </>
                            )}
                        </ButtonGroup>

                        <Spacer />

                        <HStack spacing='3'>
                            {accessToken?.length ? (
                                <LogOutButton />
                            ) : (
                                <Button as={NavLink} to={'/login'}>
                                    Login
                                </Button>
                            )}
                        </HStack>

                    </HStack>
                </Container>
            </Box>
        </Box>
    )
}
